module.exports = __webpack_public_path__ + "img/team-01.18f7eeea.jpg";